// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import Admin__BuildMpsController from './admin/build_mps_controller'
application.register('admin--build-mps', Admin__BuildMpsController)

import Admin__CitySelectorController from './admin/city_selector_controller'
application.register('admin--city-selector', Admin__CitySelectorController)

import Admin__FfidCorrectionController from './admin/ffid_correction_controller'
application.register('admin--ffid-correction', Admin__FfidCorrectionController)

import Admin__Select2Controller from './admin/select2_controller'
application.register('admin--select2', Admin__Select2Controller)

import ApplicationModalOpenerController from './application_modal_opener_controller'
application.register(
  'application-modal-opener',
  ApplicationModalOpenerController
)

import AutosaveController from './autosave_controller'
application.register('autosave', AutosaveController)

import BoxberryCitiesViewerController from './boxberry_cities_viewer_controller'
application.register('boxberry-cities-viewer', BoxberryCitiesViewerController)

import BoxberryCitySelectorController from './boxberry_city_selector_controller'
application.register('boxberry-city-selector', BoxberryCitySelectorController)

import BoxberryPointViewerController from './boxberry_point_viewer_controller'
application.register('boxberry-point-viewer', BoxberryPointViewerController)

import BoxberryServicePointsMapController from './boxberry_service_points_map_controller'
application.register(
  'boxberry-service-points-map',
  BoxberryServicePointsMapController
)

import CopyController from './copy_controller'
application.register('copy', CopyController)

import CustomsButtonsController from './customs_buttons_controller'
application.register('customs-buttons', CustomsButtonsController)

import CustomsController from './customs_controller'
application.register('customs', CustomsController)

import DestinationAddressFormRendererController from './destination_address_form_renderer_controller'
application.register(
  'destination-address-form-renderer',
  DestinationAddressFormRendererController
)

import FeedbackerController from './feedbacker_controller'
application.register('feedbacker', FeedbackerController)

import LockerItemSwitcherController from './locker_item_switcher_controller'
application.register('locker-item-switcher', LockerItemSwitcherController)

import LockerItemViewerController from './locker_item_viewer_controller'
application.register('locker-item-viewer', LockerItemViewerController)

import RmaModalOpenerController from './rma_modal_opener_controller'
application.register('rma-modal-opener', RmaModalOpenerController)

import Select2__SimpleController from './select2/simple_controller'
application.register('select2--simple', Select2__SimpleController)

import Select2__FlagsController from './select2/flags_controller'
application.register('select2--flags', Select2__FlagsController)

import Select2__TagsController from './select2/tags_controller'
application.register('select2--tags', Select2__TagsController)

import ShipmentsItemsCounterController from './shipments_items_counter_controller'
application.register('shipments-items-counter', ShipmentsItemsCounterController)

import ShipmentsItemsViewerController from './shipments_items_viewer_controller'
application.register('shipments-items-viewer', ShipmentsItemsViewerController)

import ShippingMethodsController from './shipping_methods_controller'
application.register('shipping-methods', ShippingMethodsController)

import UserNotificationsSwitcherController from './user_notifications_switcher'
application.register(
  'user-notifications-switcher',
  UserNotificationsSwitcherController
)

import UserUpdaterController from './user_updater'
application.register('user-updater', UserUpdaterController)
